import React from 'react';

type Props = { progress: number; width?: number; height?: number };

export default function CircleProgressBar({
  progress,
  width = 40,
  height = 50
}: Props) {
  const radius = 20;
  const circumference = 2 * Math.PI * radius;

  // Calculate the stroke-dashoffset based on the progress
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div>
      <svg
        className="h-full w-full"
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 50 40"
      >
        <circle
          cx={`50%`}
          cy="50%"
          r={radius}
          stroke="#FF6600"
          strokeWidth="4"
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
        />

        <circle
          cx="50%"
          cy="50%"
          r={radius - 2}
          fill="white"
          filter="url(#drop-shadow)"
        />

        <defs>
          <filter id="drop-shadow">
            <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#FF6600" />
          </filter>
        </defs>
      </svg>
    </div>
  );
}
